<template>
  <geo-json-source :data="data" :source-id="props.sourceId">
    <layer-group
      :hide-layer="hideLayer"
      :layers="layers"
      :filter="filter"
      :before="props.before"
      @click="handleClick"
    />
  </geo-json-source>
</template>

<script setup lang="ts">
import { MapMouseEvent, GeoJSONFeature, LayerSpecification } from 'mapbox-gl'
import type { Geometry, Feature, FeatureCollection } from 'geojson'
import LocationDTO from '@/models/location'
import GeoJsonSource from '../mapbox/GeoJsonSource.vue'
import LayerGroup from '../mapbox/LayerGroup.vue'
import { computed } from 'vue'
import { locationPinStyle } from './styles/location-pin'

const props = defineProps<{
  layerId: string
  sourceId: string
  showLocations?: LocationDTO[]
  hideLocations?: LocationDTO[]
  before?: string
  hideLayer?: boolean
}>()

const emits = defineEmits<{
  (event: 'click', data: GeoJSONFeature[], eventData: MapMouseEvent)
}>()

const handleClick = (data: GeoJSONFeature[], eventData: MapMouseEvent) => {
  emits('click', data, eventData)
}

const data = computed<FeatureCollection<Geometry>>(() => {
  const features =
    props.showLocations?.map<Feature>((location: LocationDTO) => ({
      id: location.id ?? undefined,
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [location.longitude!, location.latitude!],
      },
      properties: {
        Name: location.location,
        Icon: location.icon,
        IconColor: location.locationStatusColorHexCode,
        OwnerId: location.ownerId,
      },
    })) ?? []

  return {
    type: 'FeatureCollection',
    features,
  }
})

const filter = computed(() => {
  const arr: any[] = ['all']
  const ids = props.hideLocations?.map((l) => l.id) ?? []

  if (ids.length > 0) {
    arr.push(['!', ['in', ['id'], ['literal', ids]]])
  }

  return arr
})

const layers: LayerSpecification[] = [
  {
    id: props.layerId,
    source: props.sourceId,
    type: 'symbol',
    layout: {
      ...locationPinStyle.layout,
    },
    paint: {
      ...locationPinStyle.paint,
    },
  },
]
</script>
